{
  "toolbar.search": "Rechercher dans le terminal…",
  "toolbar.searchButton": "Rechercher (Ctrl+Maj+F)",
  "toolbar.copy": "Copier la sélection",
  "toolbar.paste": "Coller",
  "toolbar.fontDecrease": "Réduire la police",
  "toolbar.fontIncrease": "Agrandir la police",
  "toolbar.theme": "Changer de thème (sombre, clair, contraste)",
  "toolbar.pedagogy": "Parcours et défis",
  "toolbar.menu": "Menu",
  "menu.theme": "Thème",
  "menu.themeDark": "Sombre",
  "menu.themeLight": "Clair",
  "menu.themeContrast": "Contraste élevé",
  "menu.colors": "Colorer la console",
  "menu.clear": "Effacer l'écran",
  "menu.about": "À propos",
  "menu.cheatsheets": "Télécharger les fiches mémo",
  "menu.export": "Exporter ma sauvegarde",
  "menu.import": "Importer une sauvegarde",
  "menu.reset": "Réinitialiser la machine Debian",
  "menu.deleteAccount": "Supprimer mon compte",
  "menu.lock": "Verrouiller la session",
  "menu.logout": "Se déconnecter",
  "panel.title": "Parcours",
  "panel.tabActive": "En cours",
  "panel.tabTutorials": "Tutoriels",
  "panel.tabChallenges": "Défis",
  "panel.tutorialBadge": "Tutoriel",
  "panel.challengeBadge": "Défi",
  "panel.difficulty": "difficulté",
  "panel.journal": "Journal",
  "panel.journalEmpty": "Les validations apparaîtront ici.",
  "panel.flagLabel": "Drapeau NSI{…}",
  "panel.flagSubmit": "Valider",
  "panel.stop": "Abandonner",
  "panel.browseTutorials": "Voir les tutoriels",
  "panel.browseChallenges": "Voir les défis",
  "panel.fontDecrease": "Réduire la police du panneau",
  "panel.fontIncrease": "Agrandir la police du panneau",
  "panel.legend": "○ à faire · ▶ en cours · ✓ validé",
  "panel.close": "Fermer le panneau",
  "panel.emptyIntro": "Choisis un tutoriel ou un défi dans les onglets.",
  "panel.emptyHint": "Ta progression est enregistrée dans ton compte.",
  "panel.startTutorial": "Démarrer ce tutoriel",
  "panel.startChallenge": "Démarrer ce défi",
  "panel.hint": "Indice",
  "panel.skip": "Passer",
  "panel.level": "Niveau",
  "panel.badge": "badge",
  "panel.badges": "badges",
  "panel.tutorialsCount": "Tutoriels",
  "panel.challengesCount": "Défis",
  "panel.tutorialByTrack": "Tutoriels par parcours",
  "panel.challengeByLevel": "Défis par niveau",
  "panel.tutorialPrefix": "Tutoriel —",
  "panel.challengePrefix": "Défi —",
  "panel.step": "Étape",
  "panel.challengeGoal": "Trouve le drapeau puis valide-le ci-dessous",
  "status.local": "local — aucune donnée envoyée"
}
